<template>
  <div class="empty">
    <div class="empty__mark" aria-hidden="true"><slot name="icon">◇</slot></div>
    <p class="empty__title">{{ title }}</p>
    <p v-if="description" class="empty__description">{{ description }}</p>
    <div v-if="$slots.default" class="empty__action"><slot /></div>
  </div>
</template>

<script setup>
defineProps({ title: { type: String, required: true }, description: String })
</script>

<style scoped>
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: var(--space-10) var(--space-4);
}
.empty__mark {
  font-size: 28px;
  color: var(--color-text-mute);
  margin-bottom: var(--space-3);
}
.empty__title { font-weight: 600; }
.empty__description {
  font-size: var(--text-sm);
  color: var(--color-text-soft);
  margin-top: var(--space-1);
  max-width: 44ch;
}
.empty__action { margin-top: var(--space-4); }
</style>
